import enums from '@/lang/nl/enums';
import { errorMessages } from '@/lang/nl/error';
import { infoMessages } from '@/lang/nl/info';
import { successMessages } from '@/lang/nl/success';
import { warningMessages } from '@/lang/nl/warning';
import { createI18n } from 'vue-i18n';

export default createI18n({
    legacy: false,
    locale: 'nl',
    messages: { nl: { enums, error: errorMessages, info: infoMessages, success: successMessages, warning: warningMessages } }
});
